"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _loading = require("@/mixins/loading/loading");

var _lastMileV = require("@/mixins/last-mile-v2/last-mile-v2");

var _autoLogout = require("@/mixins/auto-logout/auto-logout");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MainLogsComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MainLogsComponent, _Mixins);

  var _super = _createSuper(MainLogsComponent);

  function MainLogsComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, MainLogsComponent);
    _this = _super.apply(this, arguments);
    _this.data = [];
    _this.truckData = [];
    _this.plateNumber = '';
    _this.code = _this.helper.currentDate;
    return _this;
  }

  (0, _createClass2.default)(MainLogsComponent, [{
    key: "$timezone",
    get: function get() {
      return this.helper.get(this.$userData, 'timezone', 8);
    }
  }, {
    key: "created",
    value: function created() {
      // this.loading = true;
      this.getInitData();
    }
  }, {
    key: "getInitData",
    value: function () {
      var _getInitData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var trucksResponse;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loading = true;
                _context.next = 3;
                return this.lastMileDeliveryAPI.getAllTrucks({
                  userId: this.$userInformation['user']['id'],
                  limit: 500,
                  order: 'PlateNum:ASC',
                  date: '0000-00-00'
                });

              case 3:
                trucksResponse = _context.sent;
                this.truckData = this.helper.get(trucksResponse, 'data', []);
                this.loading = false;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getInitData() {
        return _getInitData.apply(this, arguments);
      }

      return getInitData;
    }()
  }, {
    key: "getLogsData",
    value: function () {
      var _getLogsData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var finalFilter, filterQuery, logsResponse;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.loading = true;
                finalFilter = [{
                  queryType: 'AND',
                  key: 'type',
                  value: 'LASTMILE'
                }, {
                  queryType: 'AND',
                  key: 'code',
                  value: this.code
                }];

                if (!this.plateNumber || this.plateNumber !== '') {
                  finalFilter.push({
                    queryType: 'AND',
                    key: 'data.plateNumber',
                    value: this.plateNumber
                  });
                }

                filterQuery = this.helper.getFilterQuery(finalFilter);
                _context2.next = 6;
                return this.lastMileDeliveryAPI.getAllLogs({
                  startDate: this.helper.subtractCurrentDate(4),
                  endDate: this.helper.addCurrentDate(1),
                  limit: 200,
                  query: filterQuery.queryAnd || ''
                });

              case 6:
                logsResponse = _context2.sent;
                this.data = this.helper.get(logsResponse, 'data', []);
                this.loading = false;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getLogsData() {
        return _getLogsData.apply(this, arguments);
      }

      return getLogsData;
    }()
  }]);
  return MainLogsComponent;
}((0, _vuePropertyDecorator.Mixins)(_helper.HelperMixin, _logger.LoggerMixin, _loading.LoadingMixin, _lastMileV.LastMileDeliveryMixin, _autoLogout.AutoLogoutMixin));

MainLogsComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'MainLogsComponent',
  components: {
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-button': _elementUi.Button,
    'el-table': _elementUi.Table,
    'el-date-picker': _elementUi.DatePicker,
    'el-table-column': _elementUi.TableColumn
  }
})], MainLogsComponent);
var _default = MainLogsComponent;
exports.default = _default;